import {
  getBasicInfo,
  getMemoCardProjectList,
  getPortfolioCardProjectList,
  getPortfolioInfo,
  getProjectProcess,
  getTsCardProjectList,
  getTsProjectList
} from '@/services/project/index'
import type { Effect, Reducer } from 'umi'
import type { ProjectModelState } from './connect'

export interface ProjectModelType {
  namespace: 'project'
  state: ProjectModelState
  effects: {
    getProjectInfo: Effect
    getMemoProjectCardList: Effect
    getTsProjectCardList: Effect
    getProjectTsList: Effect
    getPortfolioProjectCardList: Effect
    getProjectPortfolioDetail: Effect
    getProjectProcess: Effect
  }
  reducers: {
    saveProjectInfo: Reducer<ProjectModelState>
    saveMemoProjectCardList: Reducer<ProjectModelState>
    saveTsProjectCardList: Reducer<ProjectModelState>
    saveProjectTsList: Reducer<ProjectModelState>
    savePortfolioProjectCardList: Reducer<ProjectModelState>
    saveProjectPortfolioList: Reducer<ProjectModelState>
    saveProjectPortfolioDetail: Reducer<ProjectModelState>
    saveProjectProcess: Reducer<ProjectModelState>
  }
}

const ProjectModel: ProjectModelType = {
  namespace: 'project',
  state: {
    projectInfo: {
      assign_info: null,
      audit_info: null,
      competitor_list: [],
      member_list: [],
      my_watch_info: null,
      newest_log: null,
      newest_memo: null,
      operation_logs: [],
      portfolio_info: null,
      project: null,
      newest_memo_tc: null
    },
    memoProjectCardList: [],
    tsProjectCardList: [],
    projectTsList: [],
    portfolioProjectCardList: [],
    projectPortfolioList: [],
    projectPortfolioDetail: {
      id: 0,
      pcode: '',
      portfolio_log: [],
      portfolio_owner_log: [],
      memo_list: []
    },
    projectProcess: []
  },
  effects: {
    *getProjectInfo({ payload }, { call, put }) {
      const response = yield call(getBasicInfo, {
        ...payload,
        is_need_assign_info: 1,
        is_need_audit_info: 1,
        is_need_company_member: 1,
        is_need_competitor: 1,
        is_need_my_watch_info: 1,
        is_need_newest_log: 1,
        is_need_newest_memo: 1,
        is_need_operation_log: 1,
        is_need_portfolio_info: 1,
        is_need_newest_memo_tc: 1
      })
      yield put({
        type: 'saveProjectInfo',
        payload: response.data || {}
      })
      return new Promise((resolve, reject) => {
        if (response.code == 0) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    },
    *getMemoProjectCardList({ payload }, { call, put }) {
      const response = yield call(getMemoCardProjectList, payload)
      yield put({
        type: 'saveMemoProjectCardList',
        payload: {
          data: response.data?.card,
          page: payload.page || 1
        }
      })
    },
    *getTsProjectCardList({ payload }, { call, put }) {
      const response = yield call(getTsCardProjectList, payload)
      yield put({
        type: 'saveTsProjectCardList',
        payload: {
          data: response.data?.card,
          page: payload.page || 1
        }
      })
    },
    *getProjectTsList({ payload }, { call, put }) {
      yield put({
        type: 'saveProjectTsList',
        payload: {
          data: []
        }
      })
      const response = yield call(getTsProjectList, payload)
      yield put({
        type: 'saveProjectTsList',
        payload: {
          data: response.data
        }
      })
    },
    *getPortfolioProjectCardList({ payload }, { call, put }) {
      const response = yield call(getPortfolioCardProjectList, payload)
      yield put({
        type: 'savePortfolioProjectCardList',
        payload: {
          data: response.data,
          page: payload.page || 1
        }
      })
    },
    *getProjectPortfolioDetail({ payload }, { call, put }) {
      const response = yield call(getPortfolioInfo, payload)
      yield put({
        type: 'saveProjectPortfolioDetail',
        payload: {
          data: response.data
        }
      })

      return new Promise((resolve, reject) => {
        if (response.code == 0) {
          resolve(response)
        } else {
          reject(response)
        }
      })
    },
    *getProjectProcess({ payload }, { call, put }) {
      const response = yield call(getProjectProcess, { project_id: payload.id })
      yield put({
        type: 'saveProjectProcess',
        payload: {
          data: response.data
        }
      })
    }
  },
  reducers: {
    saveProjectInfo(state, { payload }) {

      return {
        ...state,
        projectInfo: payload
      }
    },
    saveMemoProjectCardList(state, { payload }) {
      const { data, page } = payload
      let result = []

      if (page == 1) {
        result = data
      } else {
        result = state?.memoProjectCardList || []
        result.forEach((item: any, index: number) => {
          item.list = item.list.concat(data[index].list)
        })
      }

      return {
        ...state,
        memoProjectCardList: result
      }
    },
    saveTsProjectCardList(state, { payload }) {
      const { data, page } = payload
      let result = []

      if (page == 1) {
        result = data
      } else {
        result = state?.tsProjectCardList || []
        result.forEach((item: any, index: number) => {
          item.list = item.list.concat(data[index].list)
        })
      }

      return {
        ...state,
        tsProjectCardList: result
      }
    },
    saveProjectTsList(state, { payload }) {
      const { data } = payload
      return {
        ...state,
        projectTsList: data
      }
    },
    savePortfolioProjectCardList(state, { payload }) {
      const { data, page } = payload
      let result = []

      if (page == 1) {
        result = data
      } else {
        result = state?.portfolioProjectCardList || []
        result.forEach((item: any, index: number) => {
          item.list = item.list.concat(data[index].list)
        })
      }

      return {
        ...state,
        portfolioProjectCardList: result
      }
    },
    saveProjectPortfolioList(state, { payload }) {
      const { data } = payload
      return {
        ...state,
        projectPortfolioList: data
      }
    },
    saveProjectPortfolioDetail(state, { payload }) {
      const { data = {} } = payload
      return {
        ...state,
        projectPortfolioDetail: data.portfolio
      }
    },
    saveProjectProcess(state, { payload }) {
      const { data = [] } = payload
      return {
        ...state,
        projectProcess: data.process
      }
    }
  }
}
export default ProjectModel
